import { closeSnackbar, enqueueSnackbar, VariantType } from 'notistack';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as CancelOutlinedIcon } from '../assets/icons/main/close-circle-icon.svg';
import { palette } from '../theme/palette';

const action = (snackId: any) => (
  <IconButton
    onClick={() => {
      closeSnackbar(snackId);
    }}
  >
    <CancelOutlinedIcon style={{ color: palette.primary.contrastText }} />
  </IconButton>
);

const toast = (
  msg: string,
  variant: VariantType = 'default',
  key = new Date().getTime(),
  autoHideDuration: number = 3000,
  anchorOrigin: any = {
    vertical: 'top',
    horizontal: 'right',
  }
) => {
  enqueueSnackbar(msg, {
    key,
    variant,
    autoHideDuration,
    action,
    anchorOrigin,
  });
};

const Snackbar = {
  success(msg: string) {
    toast(msg, 'success');
  },
  warning(msg: string) {
    toast(msg, 'warning');
  },
  info(msg: string) {
    toast(msg, 'info');
  },
  error(msg: string) {
    toast(msg, 'error');
  },
};

export default Snackbar;
